import React from 'react';
import { Skeleton } from 'antd';

const BannerSkeleton = () => {
    return (
        <div className="pcu-w-100 pcu-h-100 pcu-radius-16 pcu-overflow-hidden pcu-pos-relative" 
             style={{ 
                 minHeight: '240px', 
                 background: 'linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)',
                 display: 'flex',
                 flexDirection: 'column',
                 justifyContent: 'center',
                 padding: '40px'
             }}>
            <div style={{ maxWidth: '300px', zIndex: 2 }}>
                {/* Category Badge Placeholder */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px' }}>
                    <div style={{ width: '28px', height: '28px', borderRadius: '50%', background: 'rgba(255,255,255,0.6)' }}></div>
                    <div style={{ width: '80px', height: '14px', borderRadius: '4px', background: 'rgba(255,255,255,0.4)' }}></div>
                </div>
                
                {/* Title Placeholder (Large) */}
                <div style={{ marginBottom: '24px' }}>
                    <div style={{ width: '180px', height: '32px', borderRadius: '6px', background: 'rgba(255,255,255,0.8)' }}></div>
                </div>
                
                {/* Button Placeholder */}
                <div>
                    <div style={{ width: '120px', height: '40px', borderRadius: '6px', background: 'rgba(255,0,0,0.5)' }}></div>
                </div>
            </div>
            
            {/* Animated Shimmer Overlay */}
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent)',
                animation: 'shimmer-banner 1.5s infinite',
                zIndex: 1
            }} />
            
            <style>{`
                @keyframes shimmer-banner {
                    0% { transform: translateX(-100%); }
                    100% { transform: translateX(100%); }
                }
            `}</style>
        </div>
    );
};

export default BannerSkeleton;
